import { Outlet, Link, useNavigate, useLocation } from 'react-router-dom';
import { BookOpen, Trophy, MessageSquare, LogOut, GraduationCap, User } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';

export default function StudentDashboard() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem('studentToken');
    toast.success('Logged out successfully');
    navigate('/student/login');
  };

  const menuItems = [
    { name: 'Quizzes', path: '/student/dashboard', icon: BookOpen },
    { name: 'My Results', path: '/student/results', icon: Trophy },
    { name: 'Add Testimonial', path: '/student/testimonial', icon: MessageSquare },
    { name: 'Profile', path: '/student/profile', icon: User },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <div className="min-h-screen bg-brand-surface">
      <nav className="bg-brand-dark text-white shadow-lg">
        <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">
          <div className="flex items-center space-x-2">
            <GraduationCap className="h-6 w-6" />
            <span className="text-xl font-bold font-display">Tutor Flex - Student Portal</span>
          </div>
          <Button
            data-testid="student-logout-btn"
            onClick={handleLogout}
            variant="ghost"
            className="text-white hover:bg-slate-700"
          >
            <LogOut className="h-4 w-4 mr-2" />
            Logout
          </Button>
        </div>
      </nav>

      <div className="max-w-7xl mx-auto px-6 py-8">
        <div className="flex flex-col md:flex-row gap-6">
          <aside className="w-full md:w-64 bg-white rounded-xl p-4 shadow-sm h-fit">
            <nav className="space-y-2">
              {menuItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  data-testid={`student-nav-${item.name.toLowerCase().replace(' ', '-')}`}
                  className={`flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors ${
                    isActive(item.path)
                      ? 'bg-brand-blue text-white'
                      : 'text-slate-600 hover:bg-slate-100'
                  }`}
                >
                  <item.icon className="h-5 w-5" />
                  <span className="font-medium">{item.name}</span>
                </Link>
              ))}
            </nav>
          </aside>

          <main className="flex-1">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
}
